import styled from 'styled-components';

export const OverLayerMask = styled.div`
  visibility: hidden;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #000000;
  overflow-y: auto;
  opacity: 0;
  transition: all 0.2s ease-in-out 0s;
  &.visible {
    visibility: visible;
    opacity: 0.7;
  }
`;

export const DrawerContent = styled.div`
  position: fixed;
  left: -100%;
  top: 0;
  width: 320px;
  height: 100%;
  opacity: 1;
  background-color: #ffffff;
  visibility: hidden;
  overflow-y: auto;
  transition: all 0.3s ease-in-out 0s;
  &.visible {
    visibility: visible;
    left: 0;
  }
`;

export const CloseButtonWrapper = styled.div`
  position: absolute;
  top: 18px;
  right: 18px;
`;
